import { Component, ViewEncapsulation } from '@angular/core';
import { PhoneNumberSheetComponent } from '@sc/ui-components';
import { PhoneNumberOutputData } from '@sc/data-access-models';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'sc-phone-number-bottom-sheet',
  styleUrls: ['./phone-number-bottom-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [PhoneNumberSheetComponent],
  template: `
    <sc-phone-number-sheet
      (phoneNumberResult)="onCloseSheet($event)"
    ></sc-phone-number-sheet>
  `,
})
export class PhoneNumberBottomSheetComponent {
  constructor(
    private readonly bottomSheetRef: MatBottomSheetRef<
      PhoneNumberBottomSheetComponent,
      PhoneNumberOutputData
    >,
    private readonly router: Router
  ) {
    this.router.events
      .pipe(filter((e) => e instanceof NavigationStart))
      .subscribe(() => this.bottomSheetRef.dismiss());
  }

  onCloseSheet(data?: PhoneNumberOutputData) {
    this.bottomSheetRef.dismiss(data);
  }
}
